import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";

const Footer: React.FC = () => (
  <footer className="site-footer">
    <div className="footer-content">
      <div>
        <img src="/images/logo.png" alt="Tim Elektrik" className="footer-logo" />
      </div>
      <div>
        <h4>Şirket</h4>
        <ul>
          <li><Link to="/">Anasayfa</Link></li>
          <li><Link to="/about">Hakkımızda</Link></li>
          <li><Link to="/services">Hizmetlerimiz</Link></li>
          <li><Link to="/gallery">Galeri</Link></li>
          <li><Link to="/contact">İletişim</Link></li>
        </ul>
      </div>
      <div>
        <h4>Sosyal Medya</h4>
        <ul>
          <li><a href="https://www.instagram.com/tim_elektrik/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
        </ul>
      </div>
    </div>
    <div className="copyright-bar">
      © {new Date().getFullYear()} Tim Elektrik. Tüm hakları saklıdır.
    </div>
  </footer>
);

export default Footer; 